import { render } from "./NgxInfo.vue?vue&type=template&id=689901cc&scoped=true"
import script from "./NgxInfo.vue?vue&type=script&lang=js"
export * from "./NgxInfo.vue?vue&type=script&lang=js"

import "./NgxInfo.vue?vue&type=style&index=0&id=689901cc&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-689901cc"]])

export default __exports__